import Hero from "../components/sections/Hero";
import StaffAugmentation from "../components/sections/StaffAugmentation";
import CapabilityPillars from "../components/sections/CapabilityPillars";
import StatsSection from "../components/sections/StatsSection";
import VisualMarquee from "../components/sections/VisualMarquee";
import ServicesSection from "../components/sections/ServicesSection";
import IndustriesBento from "../components/sections/IndustriesBento";
import FeaturedProjects from "../components/sections/FeaturedProjects";
import ContactCTA from "../components/sections/ContactCTA";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <StaffAugmentation />
            <VisualMarquee />
            <CapabilityPillars />
            <StatsSection />
            <ServicesSection />
            <IndustriesBento />
            <FeaturedProjects />
            <ContactCTA compact />
        </div>
    );
}
